import axios from "axios";
import { Urls } from "../../../store/urls";
import { ServiceUrls } from "../../serviceUrls";

export const CountryCmsListRepo = (params) => {
  return axios({
    baseURL:
      ServiceUrls.COUNTRY_SERVICE +
      axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "GET",
    url: Urls.GET_CMS_COUNTRY_LIST,
    params: params,
  });
};
export const getCountryCmsOverviewRepo = (params) => {
  return axios({
    baseURL:
      ServiceUrls.COUNTRY_SERVICE +
      axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "GET",
    url: Urls.GET_CMS_COUNTRY_OVERVIEW,
    params: params,
  });
};
export const putCountryCmsOverviewRepo = (params, data) => {
  return axios({
    baseURL:
      ServiceUrls.COUNTRY_SERVICE +
      axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "PUT",
    url: Urls.GET_CMS_COUNTRY_OVERVIEW,
    params: params,
    data: data,
  });
};
export const deleteCountryCmsOverviewRepo = (params) => {
  return axios({
    baseURL:
      ServiceUrls.COUNTRY_SERVICE +
      axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "DELETE",
    url: Urls.GET_CMS_COUNTRY_OVERVIEW,
    params: params,
  });
};
export const getCountryCmsCurrencyLanguagesRepo = (params) => {
  return axios({
    baseURL:
      ServiceUrls.COUNTRY_SERVICE +
      axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "GET",
    url: Urls.GET_CMS_COUNTRY_LANGUAGES,
    params: params,
  });
};
export const getCountryCmsPopularPlacesRepo = (params) => {
  return axios({
    baseURL:
      ServiceUrls.COUNTRY_SERVICE +
      axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "GET",
    url: Urls.GET_CMS_COUNTRY_POPULAR_PLACES,
    params: params,
  });
};
export const getCountryCmsFaqsRepo = (params) => {
  return axios({
    baseURL:
      ServiceUrls.COUNTRY_SERVICE +
      axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "GET",
    url: Urls.GET_CMS_COUNTRY_FAQS,
    params: params,
  });
};
export const putCountryCmsFaqsRepo = (params, data) => {
  return axios({
    baseURL:
      ServiceUrls.COUNTRY_SERVICE +
      axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "PUT",
    url: Urls.GET_CMS_COUNTRY_FAQS,
    params: params,
    data: data,
  });
};
export const getCountryCmsBasicDetailsRepo = (params) => {
  return axios({
    baseURL:
      ServiceUrls.COUNTRY_SERVICE +
      axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "GET",
    url: Urls.GET_CMS_COUNTRY_BASIC_DETAILS,
    params: params,
  });
};
export const putCountryCmsBasicDetailsRepo = (params, data) => {
  return axios({
    baseURL:
      ServiceUrls.COUNTRY_SERVICE +
      axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "PUT",
    url: Urls.GET_CMS_COUNTRY_BASIC_DETAILS,
    params: params,
    data: data,
  });
};
export const getCountryCmsContentDetailsRepo = (params) => {
  return axios({
    baseURL:
      ServiceUrls.COUNTRY_SERVICE +
      axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "GET",
    url: Urls.GET_CMS_COUNTRY_CONTENT_DETAILS,
    params: params,
  });
};
export const putCountryCmsContentDetailsRepo = (params, data) => {
  return axios({
    baseURL:
      ServiceUrls.COUNTRY_SERVICE +
      axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "PUT",
    url: Urls.GET_CMS_COUNTRY_CONTENT_DETAILS,
    params: params,
    data: data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
export const getCountryCmsMediaRepo = (params) => {
  return axios({
    baseURL:
      ServiceUrls.COUNTRY_SERVICE +
      axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "GET",
    url: Urls.GET_CMS_COUNTRY_MEDIA,
    params: params,
  });
};

export const putCountryCmsMediaRepo = (params, data) => {
  return axios({
    baseURL:
      ServiceUrls.COUNTRY_SERVICE +
      axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "PUT",
    url: Urls.GET_CMS_COUNTRY_MEDIA,
    params: params,
    data: data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};